import React from 'react'
import Navbar from '../../components/navbar'
import bg1 from '../../assets/images/bg.jpg'
import { Link } from 'react-router-dom'
import Shape from '../../components/shape'
import ShapeTwo from '../../components/shape-two'
import Footer from '../../components/footer'

export default function PageLogin() {
  return (
    <>
     <Navbar/> 

    <section className="bg-half-170 bg-light d-table w-100" style={{backgroundImage:`url(${bg1})`, backgroundPosition:'center'}}>
        <div className="bg-overlay bg-overlay-white"></div>
        <div className="container">
            <div className="row mt-5 text-center align-items-center">
                <div className="col-sm-6">
                    <div className="text-sm-start">
                        <div className="page-next-level">
                            <h4 className="title">Login</h4>
                            <p className="text-muted mb-0">Login & Signin your account now</p>                                        
                        </div>
                    </div>
                </div>

                <div className="col-sm-6 mt-4 mt-sm-0 pt-2 pt-sm-0">
                    <div className="page-next-level text-sm-end">
                        <ul className="page-next ps-0 mb-0">
                            <li className="list-inline-item"><Link to="/" className="text-uppercase fw-bold text-dark">Home</Link></li>
                            <li className="list-inline-item"><Link to="#" className="text-uppercase fw-bold text-dark">Pages</Link></li>
                            <li className="list-inline-item"><Link to="#" className="text-uppercase fw-bold text-dark">Authentication</Link></li>
                            <li className="list-inline-item">
                                <span className="text-uppercase text-primary fw-bold">Login</span> 
                            </li> 
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <ShapeTwo/>

    <section className="section">
        <div className="container">
            <div className="row justify-content-center">
                <div className="col-lg-5 col-md-8">
                    <div className="login_page">
                        <form className="login-form">
                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="mb-3">
                                        <label className="form-label">Username or email address <span className="text-danger">*</span></label>
                                        <input type="email" className="form-control" placeholder="Email" name="email" required=""/>
                                    </div>
                                </div>

                                <div className="col-lg-12">
                                    <div className="mb-3">
                                        <label className="form-label">Password <span className="text-danger">*</span></label>
                                        <input type="password" className="form-control" placeholder="Password" required=""/>
                                    </div>
                                </div>

                                <div className="col-lg-12">
                                    <div className="mb-3">
                                        <div className="form-check">
                                            <input className="form-check-input" type="checkbox" value="" id="flexCheckDefault"/>
                                            <label className="form-check-label" htmlFor="flexCheckDefault">Remember me</label>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-12 mb-0">
                                    <button className="btn btn-primary w-100">Login</button>
                                </div>
                                <div className="col-12 text-center">
                                    <p className="mb-2 mt-4"><Link to="/page-forgot-password" className="text-dark fw-bold">Forgot your password ?</Link></p>
                                    <p className="mb-0"><small className="text-dark me-2">Don't have an account ?</small> <Link to="/page-signup" className="text-dark fw-bold">Sign Up</Link></p>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <Shape/>
    <Footer/>
    </>
  )
}
